/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UploadStudentAssignmentDocument$Params {
  profileId: string;
  id: string;
      body?: {
'file'?: Blob;
}
}

export function uploadStudentAssignmentDocument(http: HttpClient, rootUrl: string, params: UploadStudentAssignmentDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, uploadStudentAssignmentDocument.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

uploadStudentAssignmentDocument.PATH = '/studentprofile/{profileId}/assignment/{id}/document';
